import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

declare var $: any;
@Injectable()
export class UtilityService {

    constructor(private titleService: Title, private router: Router) {
    }

    setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }

    navigateToLoginPage(): void {
        this.router.navigate(['/', 'login']);
    }

    navigateToHomePage(): void {
        this.router.navigate(['/']);
    }

    removeBy_id(items: Array<any>, id) {
        const index = items.findIndex(single => single._id === id);
        if (index > -1) {
            items.splice(index, 1);
        }
    }

    replaceBy_id(items: Array<any>, item, id) {
        const index = items.findIndex(single => single._id === id);
        if (index > -1) {
            items[index] = item;
        }
    }
}
